import { useState } from 'react';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { useDirectSpeech } from '../../DirectSpeech/DirectSpeechProvider';
import bundle from '../NovaComponents-TiledLayout-gui-icu.properties';
const useTextLocalizer = createUseTextLocalizer(bundle);
export const useTiledLayoutState = props => {
  const localize = useTextLocalizer();
  const directSpeech = useDirectSpeech();
  const {
    initialSelectedTiles,
    getTileKey,
    selectionMode,
    allowDeselection,
    disableInteractiveMode
  } = props;
  const [selectedTiles, setSelectedTiles] = useState(initialSelectedTiles ?? new Set());
  const [currentSelectedTile, setCurrentSelectedTile] = useState();
  const onTileSelect = e => {
    // if no index was provided, just return
    if (e.index === undefined) return;
    const tileKey = getTileKey(e.index);
    const tileIndex = e.index;
    const ctrlKey = e.ctlKey;
    const shiftKey = e.shiftKey;
    const metaKey = e.metaKey;
    let selectionType = 'select';
    if (selectionMode === 'desktop' || selectionMode === 'multiple') {
      if (shiftKey) {
        selectionType = 'range';
      } else if (ctrlKey || metaKey) {
        selectionType = 'toggle';
      }
    }
    const isSelected = selectedTiles.has(tileKey);
    let newSelectedTiles;
    const disallowDeselection = selectionMode === 'desktop' && allowDeselection === false;
    switch (selectionMode) {
      case 'single':
        newSelectedTiles = new Set();
        // if the tile is selected and deselection is allowed,
        // deselect the tile
        if (isSelected) {
          if (!allowDeselection) return;
          setCurrentSelectedTile(undefined);
          directSpeech?.notify(localize('unselected.aria'));
        } else {
          // otherwise select the tile
          newSelectedTiles.add(tileKey);
          setCurrentSelectedTile(tileIndex);
        }
        break;
      case 'desktop':
      case 'multiple':
        if (selectionType === 'toggle') {
          newSelectedTiles = new Set(selectedTiles);
          // toggle the select state of node and keep other selected nodes as it is
          if (isSelected) {
            newSelectedTiles.delete(tileKey);
            setCurrentSelectedTile(undefined);
          } else {
            newSelectedTiles.add(tileKey);
            setCurrentSelectedTile(tileIndex);
          }
        } else if (selectionType === 'range') {
          // select the range of nodes starting from the last selected node
          let iStart = tileIndex;
          let iEnd = currentSelectedTile ?? iStart;
          if (iStart > iEnd) {
            [iStart, iEnd] = [iEnd, iStart];
          }
          newSelectedTiles = ctrlKey || e.selectionArea === 'checkbox' ? new Set(selectedTiles) : new Set();
          for (let i = iStart; i <= iEnd; i++) {
            newSelectedTiles.add(getTileKey(i));
          }
        } else {
          newSelectedTiles = e.selectionArea !== 'checkbox' ? new Set() : new Set(selectedTiles);
          if (isSelected && (selectedTiles.size === 1 && !disallowDeselection || e.selectionArea === 'checkbox')) {
            newSelectedTiles.delete(tileKey);
            setCurrentSelectedTile(undefined);
          } else {
            newSelectedTiles.add(tileKey);
            setCurrentSelectedTile(tileIndex);
          }
        }
        break;
      default:
        break;
    }
    if (newSelectedTiles) {
      setSelectedTiles(newSelectedTiles);
      props.onSelect?.(newSelectedTiles, tileKey);
    }
  };
  return {
    getTileKey,
    selectedTiles,
    selectionMode,
    disableInteractiveMode,
    onTileSelect,
    setSelectedTiles,
    setCurrentSelectedTile
  };
};
//# sourceMappingURL=useTiledLayoutState.js.map